import React from 'react'

export const actionTypes = {
  RESET: 'RESET',
  SUBMIT_INIT: 'SUBMIT_INIT',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SUBMIT_FAIL: 'SUBMIT_FAIL',
  VALID_FORM: 'VALID_FORM',
  INVALID_FORM: 'INVALID_FORM',
}

const initialState = {
  isFormValid: false,
  isSubmitting: false,
  error: null,
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_INIT: {
      return {
        ...state,
        isSubmitting: true,
        error: null,
      }
    }
    case actionTypes.RESET: {
      return initialState
    }
    case actionTypes.SUBMIT_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
      }
    }
    case actionTypes.SUBMIT_FAIL: {
      return {
        ...state,
        isSubmitting: false,
        error: action.error,
      }
    }
    case actionTypes.VALID_FORM: {
      return {
        ...state,
        isFormValid: true,
      }
    }
    case actionTypes.INVALID_FORM: {
      return {
        ...state,
        isFormValid: false,
      }
    }
    default: {
      throw new Error('Not supported action')
    }
  }
}

const useFormState = () => {
  return React.useReducer(reducer, initialState)
}

export default useFormState
